import {ICompanySyncstep, ICompanySyncstepFilter} from "../../../../../index";
import {ErrorManager} from "../../../../../error/ErrorManager";
import {ObjectTypeId} from "../../../../../constants/ObjectTypeId";

interface IMutableSyncstepFilterParams {
    companySyncstep: ICompanySyncstep
    errorManager: ErrorManager
    filter: ICompanySyncstepFilter
    isDeleted: boolean
}

interface ICompositeCompanySyncstepFilter {
    filter: ICompanySyncstepFilter | null
    objDef: IObjectDefinition | null
    objectTypeId: ObjectTypeId
    icon: string
    iconCls: string
}